import(/* webpackMode: "eager", webpackExports: ["LegacyRendererWithCatwalkProvider"] */ "/opt/build/repo/packages/apg/frontend/frontasticBridge/bridge/js/LegacyRendererWithCatwalkProvider.tsx");
